<template>
  <el-input
    ref="input"
    type="textarea"
    :autosize="autosize"
    size="mini"
    class="live-editor-cell__textarea"
    :class="{ 'live-editor-cell__textarea--scroll': scrollable }"
    :value="value"
    :placeholder="placeholder"
    :disabled="disabled"
    @input="onInput"
  />
</template>

<script lang="ts">
import Vue from 'vue';

/** 默认一行，随内容增高；超过 maxRows 后由 Element 固定高度，配合 CSS overflow 滚动 */
export const PATCH_TEXTAREA_AUTOSIZE = { minRows: 1, maxRows: 6 };

export default Vue.extend({
  name: 'LiveEditorPatchTextarea',
  props: {
    value: { type: String, default: '' },
    placeholder: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      autosize: PATCH_TEXTAREA_AUTOSIZE,
      scrollable: false,
    };
  },
  watch: {
    value() {
      this.scheduleResize();
    },
    disabled() {
      this.scheduleResize();
    },
  },
  mounted() {
    this.scheduleResize();
  },
  methods: {
    onInput(value: string) {
      this.$emit('input', value);
      this.scheduleResize();
    },
    scheduleResize() {
      this.$nextTick(() => {
        const input = this.$refs.input as {
          resizeTextarea?: () => void;
          $refs?: { textarea?: HTMLTextAreaElement };
        };
        input?.resizeTextarea?.();
        this.$nextTick(() => this.syncScrollable(input));
      });
    },
    syncScrollable(
      input?: {
        $refs?: { textarea?: HTMLTextAreaElement };
      },
    ) {
      const el = input?.$refs?.textarea ?? (this.$refs.input as { $refs?: { textarea?: HTMLTextAreaElement } })?.$refs
        ?.textarea;
      if (!el) {
        this.scrollable = false;
        return;
      }
      // 仅内容超出可视高度时显示纵向滚动条（单行/未顶满时不出现）
      this.scrollable = el.scrollHeight - el.clientHeight > 1;
    },
  },
});
</script>

<style lang="scss" scoped>
.live-editor-cell__textarea ::v-deep textarea {
  overflow-x: hidden;
  overflow-y: hidden;
}

.live-editor-cell__textarea--scroll ::v-deep textarea {
  overflow-y: auto;
}
</style>
